import React from 'react';
import { DatePicker, Space, Dropdown, Menu, Input } from 'antd';
import { DownOutlined } from '@ant-design/icons';

export interface ListDropdown {
  list: any;
  titleSelect?: string;
  className?: string;
}
const DropdownAction = (props: ListDropdown) => {
  return (
    <Dropdown
      overlay={props.list}
      trigger={['click']}
      className={` ${props.className}? ${props.className} : dropdownWare`}
    >
      <a onClick={(e) => e.preventDefault()}>
        <Space
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {props.titleSelect}
          <DownOutlined />
        </Space>
      </a>
    </Dropdown>
  );
};

export default DropdownAction;
